import styled, { css } from "styled-components";

import { TextCell } from "@similarweb/pro-logic-components";
import { Flex } from "@similarweb/ui-components/foundations";

// We define a wrapper with custom styles to not modify the shared ExpansionButtonCell component
export const KeywordCellRoot = styled.div`
    width: 100%;
    min-width: 0;

    > div {
        .cell-innerText {
            flex: 1 1 0;
            min-width: 0;
            overflow: visible;
            white-space: normal;
            text-overflow: unset;
            padding: 4px 0;
        }
    }
`;

export const KeywordWithBadgeWrapper = styled(Flex)`
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    row-gap: 4px;
    min-width: 0;
    width: 100%;
`;

/* Wrap keyword max 2 lines */
export const KeywordTextCell = styled(TextCell)<{ $withBadge?: boolean }>`
    min-width: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
    overflow-wrap: break-word;

    ${({ $withBadge }) =>
        $withBadge
            ? css`
                  flex: 0 1 auto;
                  width: fit-content;
                  max-width: 100%;
              `
            : css`
                  flex: 1 1 0;
              `}
`;
